import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconDatabaseLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 20.5c-2.427 0-4.45-.343-6.07-1.028S3.5 17.931 3.5 16.904V7c0-.965.83-1.79 2.489-2.474C7.647 3.842 9.65 3.5 12 3.5s4.352.342 6.012 1.026C19.67 5.21 20.5 6.035 20.5 7v9.904c0 1.027-.81 1.883-2.43 2.568S14.427 20.5 12 20.5Zm0-11.542c1.458 0 2.925-.206 4.403-.619 1.478-.412 2.334-.856 2.568-1.333-.228-.49-1.075-.947-2.541-1.37a15.884 15.884 0 0 0-8.845-.018c-1.458.412-2.316.862-2.575 1.35.252.5 1.104.956 2.556 1.37 1.452.413 2.93.62 4.434.62Zm0 5.003c.694 0 1.369-.033 2.025-.1a17.378 17.378 0 0 0 1.882-.292 12.685 12.685 0 0 0 1.68-.477c.521-.19.992-.404 1.413-.644V8.9c-.42.24-.892.454-1.413.644-.522.19-1.082.349-1.68.477a17.24 17.24 0 0 1-1.882.292c-.656.067-1.331.1-2.025.1a19.88 19.88 0 0 1-2.065-.104c-.67-.07-1.302-.17-1.896-.297a12.716 12.716 0 0 1-1.663-.473A8.146 8.146 0 0 1 5 8.9v3.548c.404.24.862.453 1.376.64a12.72 12.72 0 0 0 1.663.472 17.71 17.71 0 0 0 1.896.297c.67.07 1.359.104 2.065.104ZM12 19c.812 0 1.608-.053 2.39-.16a15.099 15.099 0 0 0 2.135-.439c.641-.185 1.182-.4 1.622-.645.44-.245.725-.502.853-.771v-3.037a9.11 9.11 0 0 1-1.413.644c-.522.19-1.082.35-1.68.477a17.24 17.24 0 0 1-1.882.292c-.656.067-1.331.1-2.025.1a19.89 19.89 0 0 1-2.065-.104 17.71 17.71 0 0 1-1.896-.297 12.72 12.72 0 0 1-1.663-.473A8.122 8.122 0 0 1 5 13.949V17c.128.276.41.532.845.768.435.237.974.448 1.615.633.64.185 1.355.331 2.142.439.787.107 1.586.16 2.398.16Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconDatabaseLine;
